import { literal, union } from 'io-ts/Decoder';

export const MeasurementSystem = union(literal('imperial'), literal('metric'));
